let watermark = {}

function getWatermarkDiv() {
  let id = '1.23452384164.123412416';
  let checkDiv = document.getElementById(id);
  if (checkDiv !== null) {
    return checkDiv;
  }
  let div = document.createElement('div');
  div.id = id;
  div.style.pointerEvents = 'none';
  div.style.top = '0px';
  div.style.left = '0px';
  div.style.right = '0px';
  div.style.bottom = '0px';
  div.style.position = 'fixed';
  div.style.zIndex = '100000';
  document.body.appendChild(div);
  return div;
}

/****绘制自动换行的字符串****/
function drawText(context, t, x, y, w) {
  var row = t.split("\n");
  for (var b = 0; b < row.length; b++) {
    context.fillText(row[b], x, y + (b + 1) * 20);
  }
}


function getWatermarkCanvas(str, width = 220, height = 180, alpha = 0.05, fontSize = 16) {
  //创建一个画布
  let can = document.createElement('canvas');
  //设置画布的长宽
  can.width = width;
  can.height = height;
  // 画布上下文
  let context = can.getContext('2d');
  // 旋转角度
  context.rotate(-15 * Math.PI / 180);
  // 设置字体大小
  context.font = fontSize + 'px Vedana';
  // 设置填充绘画的颜色、渐变或者模式
  context.fillStyle = 'rgba(0, 0, 0, ' + alpha + ')';
  // 设置文本内容的当前对齐方式
  context.textAlign = 'left';
  // 设置在绘制文本时使用的当前文本基线
  context.textBaseline = 'Middle';
  // 在画布上绘制填色的文本（输出的文本，开始绘制文本的X坐标位置，开始绘制文本的Y坐标位置）
  // context.fillText(str, can.width / 8, can.height / 2);
  drawText(context, str, can.width / 8, can.height / 2, width * 0.6)
  // 返回画布
  return can;
}

let setWatermark = (str, width, height, alpha, fontSize) => {
  let div = getWatermarkDiv();
  let can = getWatermarkCanvas(str, width, height, alpha, fontSize)
  div.style.background = 'url(' + can.toDataURL('image/png') + ') left top repeat';
}

// 该方法只允许调用一次
watermark.set = (str) => {
  setWatermark(str);
  setInterval(() => {
    if (getWatermarkDiv() === null) {
      setWatermark(str);
    }
  }, 500);
  window.onresize = () => {
    setWatermark(str);
  };
}

export default watermark;